import Nursing from "@/views/nursing/index.vue";

export default [
  {
    path: "terapeutica",
    name: "Terapêutica",
    component: Nursing,
  },
];
